import React from 'react';
import cn from 'classnames';

export interface NumberedListItem {
  /** Bold accent label below the number. At least one of accent or body must be provided. */
  accent?: string;
  /** Supporting paragraph below the accent label. */
  body?: string;
}

export interface NumberedListProps {
  items: NumberedListItem[];
  variant?: 'default' | 'inverse';
  className?: string;
}

const variantTokens = {
  default: {
    number: 'text-ds-text-1',
    accent: 'text-ds-text-1',
    body: 'text-ds-text-1',
  },
  inverse: {
    number: 'text-ds-text-4',
    accent: 'text-ds-text-inverse-3',
    body: 'text-ds-text-inverse-1',
  },
};

export const NumberedList: React.FC<NumberedListProps> = ({
  items,
  variant = 'default',
  className,
}) => {
  const tokens = variantTokens[variant];

  return (
    <ul className={cn('flex flex-wrap gap-8 items-start content-start', className)}>
      {items.map((item, i) => (
        <li key={i} className="flex flex-col gap-3 flex-1 basis-80 shrink-0 list-none">
          {/* Topic: number + accent label */}
          <div className="flex flex-col gap-1 items-start">
            <span className={cn('text-ds-headline-s font-medium whitespace-nowrap', tokens.number)}>
              {i + 1}
            </span>
            {item.accent && (
              <span className={cn('text-ds-text-s font-semibold', tokens.accent)}>
                {item.accent}
              </span>
            )}
          </div>
          {/* Body paragraph */}
          {item.body && <p className={cn('text-ds-text-s', tokens.body)}>{item.body}</p>}
        </li>
      ))}
    </ul>
  );
};

export default NumberedList;
